import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { isAfter } from 'date-fns';
import { NO_FUTURE_DATE, REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { formPaths } from '@shared/constants/form-paths.const';
import {
    checkCkNormeValue,
    codiceFiscaleHelper,
    getSpdConsiglioGestioneArray,
    getSpdConsiglioSorveglianzaArray,
    my_SpdConsiglioGestioneRequiredHelper,
    my_SpdConsiglioSorveglianzaRequiredHelper,
} from './helpers/norme-spa-dualistico-form-validators.helper';
import { checkDataFutura, controlloCaricaPresidente } from '../../common/helpers/norme-validators.helper';

export const normeSpaDualisticoConsiglioMembriRules: FormGroupRules = {
    my_SpdConsGestCarica: (form: FormGroup) => {
        const my_SpdConsGestCaricaFormArray = getSpdConsiglioGestioneArray(form);

        my_SpdConsGestCaricaFormArray?.controls?.forEach((group: FormGroup) => {
            const my_SpdConsGestCaricaControl = getControl(group, 'my_SpdConsGestCarica');
            const errors = my_SpdConsGestCaricaControl.errors ?? {};

            addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_SpdConsGestCaricaControl?.value), errors, 'my_SpdConsGestCarica', {
                status: REQUIRED_STATUS,
            });

            my_SpdConsGestCaricaControl.setErrors(isEqual(errors, {}) ? null : errors);
        });

        if (checkCkNormeValue(form)) {
            controlloCaricaPresidente(my_SpdConsGestCaricaFormArray, 'my_SpdConsGestCarica');
        }
    },

    my_SpdConsGestDataElezione: (form: FormGroup) => {
        const elemConsiglioGestione = getSpdConsiglioGestioneArray(form);
        const my_DataCompilaz: string = getControl(form, `${formPaths.conclusioni}.my_DataCompilaz`).value;

        elemConsiglioGestione.controls.forEach((group: FormGroup) => {
            const my_SpdConsGestDataElezioneControl = getControl(group, 'my_SpdConsGestDataElezione');
            const errors = my_SpdConsGestDataElezioneControl.errors ?? {};
            const dataElezione = new Date(my_SpdConsGestDataElezioneControl.value);
            const dataCompilaz = new Date(my_DataCompilaz);
            const resultLater = isAfter(dataElezione, dataCompilaz);

            addRemoveError(checkCkNormeValue(form) && resultLater && !isNilOrEmpty(my_DataCompilaz), errors, 'my_SpdConsGestDataElezione', {
                status: 'Data incoerente con la fine della revisione',
            });

            addRemoveError(checkCkNormeValue(form) && checkDataFutura(my_SpdConsGestDataElezioneControl.value), errors, 'my_SpdConsGestDataElezione', {
                status: NO_FUTURE_DATE,
            });

            addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_SpdConsGestDataElezioneControl?.value), errors, 'my_SpdConsGestDataElezione', {
                status: REQUIRED_STATUS,
            });

            my_SpdConsGestDataElezioneControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_SpdConsSorvDataElezione: (form: FormGroup) => {
        const elemConsiglioSorveglianza = getSpdConsiglioSorveglianzaArray(form);
        const my_DataCompilaz: string = getControl(form, `${formPaths.conclusioni}.my_DataCompilaz`).value;

        elemConsiglioSorveglianza.controls.forEach((group: FormGroup) => {
            const my_SpdConsSorvDataElezioneControl = getControl(group, 'my_SpdConsSorvDataElezione');
            const errors = my_SpdConsSorvDataElezioneControl.errors ?? {};
            const dataElezione = new Date(my_SpdConsSorvDataElezioneControl.value);
            const dataCompilaz = new Date(my_DataCompilaz);
            const resultLater = isAfter(dataElezione, dataCompilaz);

            addRemoveError(checkCkNormeValue(form) && resultLater && !isNilOrEmpty(my_DataCompilaz), errors, 'my_SpdConsSorvDataElezione', {
                status: 'Data incoerente con la fine della revisione',
            });

            addRemoveError(checkCkNormeValue(form) && checkDataFutura(my_SpdConsSorvDataElezioneControl.value), errors, 'my_SpdConsSorvDataElezione', {
                status: NO_FUTURE_DATE,
            });

            addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_SpdConsSorvDataElezioneControl?.value), errors, 'my_SpdConsSorvDataElezione', {
                status: REQUIRED_STATUS,
            });

            my_SpdConsSorvDataElezioneControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_SpdConsSorvCarica: (form: FormGroup) => {
        const elemConsiglioSorveglianza = getSpdConsiglioSorveglianzaArray(form);

        elemConsiglioSorveglianza.controls.map((group: FormGroup) => {
            const my_SpdConsSorvCaricaControl = getControl(group, 'my_SpdConsSorvCarica');
            const errors = my_SpdConsSorvCaricaControl.errors ?? {};

            addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_SpdConsSorvCaricaControl?.value), errors, 'my_SpdConsSorvCarica', {
                status: REQUIRED_STATUS,
            });

            my_SpdConsSorvCaricaControl.setErrors(isEqual(errors, {}) ? null : errors);
        });

        if (checkCkNormeValue(form)) {
            controlloCaricaPresidente(elemConsiglioSorveglianza, 'my_SpdConsSorvCarica');
        }
    },

    my_SpdConsSorvCognome: (form: FormGroup) => {
        my_SpdConsiglioSorveglianzaRequiredHelper(form, 'my_SpdConsSorvCognome');
    },

    my_SpdConsSorvNome: (form: FormGroup) => {
        my_SpdConsiglioSorveglianzaRequiredHelper(form, 'my_SpdConsSorvNome');
    },

    my_SpdConsSorvCodFisc: (form: FormGroup) => {
        my_SpdConsiglioSorveglianzaRequiredHelper(form, 'my_SpdConsSorvCodFisc');
        getSpdConsiglioSorveglianzaArray(form).controls.forEach((group: FormGroup) => {
            codiceFiscaleHelper(group, 'my_SpdConsSorvNome', 'my_SpdConsSorvCognome', 'my_SpdConsSorvCodFisc');
        });
    },

    my_SpdConsSorvVia: (form: FormGroup) => {
        my_SpdConsiglioSorveglianzaRequiredHelper(form, 'my_SpdConsSorvVia');
    },

    my_SpdConsSorvProvincia: (form: FormGroup) => {
        my_SpdConsiglioSorveglianzaRequiredHelper(form, 'my_SpdConsSorvProvincia');
    },

    my_SpdConsSorvComune: (form: FormGroup) => {
        my_SpdConsiglioSorveglianzaRequiredHelper(form, 'my_SpdConsSorvComune');
    },

    my_SpdConsSorvCap: (form: FormGroup) => {
        my_SpdConsiglioSorveglianzaRequiredHelper(form, 'my_SpdConsSorvCap');
    },

    my_SpdConsGestCognome: (form: FormGroup) => {
        my_SpdConsiglioGestioneRequiredHelper(form, 'my_SpdConsGestCognome');
    },

    my_SpdConsGestNome: (form: FormGroup) => {
        my_SpdConsiglioGestioneRequiredHelper(form, 'my_SpdConsGestNome');
    },

    my_SpdConsGestCodFisc: (form: FormGroup) => {
        my_SpdConsiglioGestioneRequiredHelper(form, 'my_SpdConsGestCodFisc');
        getSpdConsiglioGestioneArray(form).controls.forEach((group: FormGroup) => {
            codiceFiscaleHelper(group, 'my_SpdConsGestNome', 'my_SpdConsGestCognome', 'my_SpdConsGestCodFisc');
        });
    },

    my_SpdConsGestVia: (form: FormGroup) => {
        my_SpdConsiglioGestioneRequiredHelper(form, 'my_SpdConsGestVia');
    },

    my_SpdConsGestProvincia: (form: FormGroup) => {
        my_SpdConsiglioGestioneRequiredHelper(form, 'my_SpdConsGestProvincia');
    },

    my_SpdConsGestComune: (form: FormGroup) => {
        my_SpdConsiglioGestioneRequiredHelper(form, 'my_SpdConsGestComune');
    },

    my_SpdConsGestCap: (form: FormGroup) => {
        my_SpdConsiglioGestioneRequiredHelper(form, 'my_SpdConsGestCap');
    },
};
